export function getWordsCount(
  str: string,
  locale: string | string[] = 'und', // "zh-Hans", "ja", "th", "uk"
): number {
  if (!str || str.trim().length === 0) return 0;
  if (typeof Intl?.Segmenter === 'function') {
    const segmenter = new Intl.Segmenter(locale, { granularity: 'word' });
    let count = 0;
    for (const { isWordLike } of segmenter.segment(str)) {
      if (isWordLike) count += 1;
    }
    return count;
  }
  // fallback for old browsers
  const cjkRegex = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]/gu;
  const cjkCount = (str.match(cjkRegex) ?? []).length;
  const nonCjkText = str.replace(cjkRegex, ' ');
  const otherCount = (nonCjkText.match(/[\p{L}\p{N}]+/gu) ?? []).length;
  return cjkCount + otherCount;
}
